const state = () => {
  return {
    department_types: [],
    department_filter_types: [],
  }
}

export default state;
